<template>
  <div style="height: 100%">
    <label style="padding: 20px 0px 10px 30px;">机房温湿度</label>
    <div v-if="chartDataList.length > 0" style="height: 85%">
      <!-- 5个及以下空间直接显示 -->
      <template v-if="chartDataList.length === 1">
        <div style="height: 100%">
          <humiture-bar-chart :data="chartDataList[0]" style="height: 100%;"></humiture-bar-chart>
        </div>
      </template>
      <!-- 超过5个空间使用轮播 -->
      <template v-else>
        <el-carousel 
          :interval="10000" 
          indicator-position="none" 
          :autoplay="true" 
          style="height: 100%;z-index: 0">
          <el-carousel-item v-for="(chartData, index) in chartDataList" :key="index">
            <humiture-bar-chart :data="chartData" style="height: 100%;"></humiture-bar-chart>
          </el-carousel-item>
        </el-carousel>
      </template>
    </div>
    <div v-else style="height: 100%;padding-top: 20%">
      <no-data></no-data>
    </div>
  </div>
</template>

<script>
import HumitureBarChart from "@/components/echarts/HumitureBarChart";
import NoData from "@/components/NoData";
import { getTemperatureAndHumidityHistogram } from "@/network/measuring-point-history";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "controlRoomHumitureBar",
  mixins: [platenLayoutEdit],
  components: { HumitureBarChart, NoData },
  data() {
    return {
      chartDataList: [], // 分组后的图表数据列表
      pageSize: 5 // 每页显示的空间数量
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$store.dispatch('addIntervalObj', { 'getHumitureBarData:10000': this.getData })
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getHumitureBarData')
  },
  methods: {
    // 获取所有空间的温湿度数据
    getData() {
      getTemperatureAndHumidityHistogram().then(res => {
        if (res.code === 0 && res.data && res.data.length > 0) {
          // 所有空间都显示，包括空数据的空间
          this.chartDataList = this.chunkData(res.data, this.pageSize);
        } else {
          this.chartDataList = [];
        }
      }).catch(() => {
        this.chartDataList = [];
      });
    },
    // 将数据分组
    chunkData(data, size) {
      const result = [];
      for (let i = 0; i < data.length; i += size) {
        const chunk = data.slice(i, i + size);
        result.push({
          spaceNames: chunk.map(item => item.spaceName || '未知'),
          temperatures: chunk.map(item => item.tempAvg || 0),
          humidities: chunk.map(item => item.humiAvg || 0)
        });
      }
      return result;
    },
    skipOverview(spaceInfo) {
      if (this.isPlatenLayoutEditing) return
      const deviceInfo = {
        spaceId: spaceInfo.id || spaceInfo.spaceId,
        spaceName: spaceInfo.spaceName || spaceInfo.cnName
      };
      this.$emit('skipOverview', deviceInfo, 'environment_category_tag');
    }
  }
}
</script>

<style scoped>
label {
  font-weight: bold;
  color: #01EFFD;
}

.el-carousel >>> .el-carousel__arrow {
  top: 5%;
}
</style>

